(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function waennInitMegaMenu() {
    var panel = document.getElementById('WaennMegaMenu');
    if (!panel) return;

    var candidateTriggers = document.querySelectorAll('.header__inline-menu a, .header__inline-menu summary');
    var trigger = null;
    candidateTriggers.forEach(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      if (text.indexOf('edici') === 0) {
        trigger = el;
      }
    });
    if (!trigger) return;

    var closeTimer;

    function openMenu() {
      clearTimeout(closeTimer);
      panel.classList.add('is-open');
      document.body.classList.add('waenn-mega-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        document.body.classList.remove('waenn-mega-open');
      }, 150);
    }

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    panel.addEventListener('mouseleave', scheduleClose);

    // WAENN: en escritorio "Edicion Limitada" ahora tiene submenu real (para
    // que el menu movil lo despliegue, ver navegacion main-menu), asi que
    // snippets/header-dropdown-menu.liquid lo envuelve en <summary>/<details>
    // nativo en vez de un <a> suelto. El desplegable nativo se oculta por CSS
    // (clase waenn-mega-trigger, ver assets/waenn-mega-menu-colecciones.css)
    // y la interaccion principal en escritorio sigue siendo el hover sobre el
    // mega menu personalizado de arriba -- evitamos que el click abra/cierre
    // el <details> nativo, igual que ya se hace para "Colecciones".
    if (trigger.tagName === 'SUMMARY') {
      trigger.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 990px)').matches) {
          e.preventDefault();
        }
      });
    }
  }

  function waennInitMegaMenuColecciones() {
    var panel = document.getElementById('WaennMegaMenuColecciones');
    var trigger = document.querySelector('.waenn-mega-trigger--colecciones');
    if (!panel || !trigger) return;

    var closeTimer;

    function openMenu() {
      clearTimeout(closeTimer);
      panel.classList.add('is-open');
      document.body.classList.add('waenn-mega-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        document.body.classList.remove('waenn-mega-open');
      }, 150);
    }

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    panel.addEventListener('mouseleave', scheduleClose);

    // En escritorio, el trigger es un <summary> dentro de un <details> nativo.
    // Evitamos que el click abra el desplegable nativo (que ocultamos por CSS),
    // ya que la interaccion principal en escritorio es el hover sobre el mega menu.
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        e.preventDefault();
      }
    });
  }

  // WAENN — Offset real de la barra superior (aviso + header), usado por los
  // drawers laterales (carrito y guardados) para que su primera tarjeta
  // (titulo + boton de cerrar) nazca justo debajo del menu real, en vez de
  // quedar pintada detras de el. --header-height (Dawn) solo mide la altura
  // propia de .section-header y NO incluye la barra de anuncios que va
  // encima; getBoundingClientRect().bottom si la incluye, porque el header
  // ya esta desplazado hacia abajo por ella en el flujo normal.
  function waennUpdateChromeOffset() {
    var headerEl = document.querySelector('.section-header') || document.querySelector('.header');
    if (!headerEl) return;
    var rect = headerEl.getBoundingClientRect();
    var offset = Math.max(Math.round(rect.bottom), 0);
    document.documentElement.style.setProperty('--waenn-chrome-offset', offset + 'px');
  }

  // WAENN — Alto real de la barra de anuncio (solo portada, donde el header
  // flota en position:fixed sobre el hero: ver body.template-index
  // .section-header en assets/waenn-header-overlay.css). Ese CSS colocaba el
  // header a un "top" fijo en px que asumia que la barra de anuncio siempre
  // mide lo mismo; en movil el texto del marquee puede necesitar otro alto
  // (tipografia/escala distinta), y un valor fijo dejaba el header mal
  // colocado -- solapado con la propia barra de anuncio, con el logo y los
  // iconos tapados y solo asomando la esquina del boton de menu. Se mide
  // aqui en tiempo real y se recalcula en cada resize, igual que ya
  // hacemos con --waenn-chrome-offset para los drawers.
  function waennUpdateAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar-section');
    if (!bar) return;
    var height = Math.round(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--waenn-announcement-height', height + 'px');
  }

  function waennWatchDrawerOffset(selector) {
    var el = document.querySelector(selector);
    if (!el) return;
    var observer = new MutationObserver(function () {
      if (el.classList.contains('active')) {
        waennUpdateChromeOffset();
      }
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function waennInitChromeOffset() {
    waennUpdateAnnouncementHeight();
    waennUpdateChromeOffset();
    waennWatchDrawerOffset('cart-drawer');
    waennWatchDrawerOffset('saved-drawer');
    window.addEventListener('resize', function () {
      waennUpdateAnnouncementHeight();
      waennUpdateChromeOffset();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waennInitMegaMenu();
      waennInitMegaMenuColecciones();
      waennInitChromeOffset();
    });
  } else {
    waennInitMegaMenu();
    waennInitMegaMenuColecciones();
    waennInitChromeOffset();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-regala"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PRESET_VARIANTS = { 60: '58506782179712', 100: '58506782212480', 150: '58506782245248' };
    var CUSTOM_VARIANTS = {
      160: '58507163632000', 170: '58507163664768', 180: '58507163697536', 190: '58507163730304',
      200: '58507163763072', 210: '58507163795840', 220: '58507163828608', 230: '58507163861376',
      240: '58507163894144', 250: '58507163926912', 260: '58507163959680', 270: '58507163992448',
      280: '58507164025216', 290: '58507164057984', 300: '58507164090752', 310: '58507164123520',
      320: '58507164156288', 330: '58507164189056', 340: '58507164221824', 350: '58507164254592',
      360: '58507164287360', 370: '58507164320128', 380: '58507164352896', 390: '58507164385664',
      400: '58507164418432', 410: '58507164451200', 420: '58507164483968', 430: '58507164516736',
      440: '58507164549504', 450: '58507164582272', 460: '58507164615040', 470: '58507164647808',
      480: '58507164680576', 490: '58507164713344', 500: '58507164746112'
    };
    var CUSTOM_MIN = 160;
    var CUSTOM_MAX = 500;
    var CUSTOM_STEP = 10;

    function snapAmount(raw) {
      var n = parseFloat(raw);
      if (isNaN(n)) return null;
      if (n < CUSTOM_MIN) n = CUSTOM_MIN;
      if (n > CUSTOM_MAX) n = CUSTOM_MAX;
      return Math.round(n / CUSTOM_STEP) * CUSTOM_STEP;
    }

    function initRegalaModal() {
      var modal = document.getElementById('RegalaGiftModal');
      if (!modal) return;

      var options = modal.querySelectorAll('.waenn-gift-option');
      var customWrap = modal.querySelector('[data-custom-wrap]');
      var customInput = modal.querySelector('#RegalaCustomAmount');
      var customHint = modal.querySelector('[data-custom-hint]');
      var submitBtn = modal.querySelector('[data-add-to-cart]');
      var errorEl = modal.querySelector('[data-modal-error]');
      var defaultHint = customHint ? customHint.textContent : '';

      var selectedVariantId = null;

      function clearSelection() {
        options.forEach(function (opt) { opt.classList.remove('is-selected'); });
        selectedVariantId = null;
        submitBtn.disabled = true;
      }

      function selectPreset(btn) {
        clearSelection();
        btn.classList.add('is-selected');
        customWrap.hidden = true;
        selectedVariantId = btn.dataset.variantId;
        submitBtn.disabled = false;
      }

      function selectCustom(btn) {
        options.forEach(function (opt) { opt.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        customWrap.hidden = false;
        selectedVariantId = null;
        submitBtn.disabled = true;
        customInput.focus();
      }

      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.amount === 'custom') {
            selectCustom(btn);
          } else {
            selectPreset(btn);
          }
        });
      });

      if (customInput) {
        customInput.addEventListener('input', function () {
          var snapped = snapAmount(customInput.value);
          if (snapped === null) {
            submitBtn.disabled = true;
            if (customHint) customHint.textContent = defaultHint;
            return;
          }
          selectedVariantId = CUSTOM_VARIANTS[snapped];
          submitBtn.disabled = !selectedVariantId;
          if (customHint) {
            customHint.textContent = 'Se añadirá una tarjeta regalo de ' + snapped + '€.';
          }
        });
      }

      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          if (!selectedVariantId) return;
          var variantId = parseInt(selectedVariantId, 10);
          var originalText = submitBtn.textContent;
          submitBtn.disabled = true;
          submitBtn.textContent = 'Añadiendo...';
          errorEl.hidden = true;
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add-failed');
              return res.json();
            })
            .then(function () {
              window.location.href = root + 'cart';
            })
            .catch(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
              errorEl.textContent = 'No se ha podido añadir la tarjeta regalo al carrito. Inténtalo de nuevo.';
              errorEl.hidden = false;
            });
        });
      }

      modal.addEventListener('modalClosed', function () {
        clearSelection();
        customWrap.hidden = true;
        if (customInput) customInput.value = '';
        if (customHint) customHint.textContent = defaultHint;
        errorEl.hidden = true;
      });
    }

    function initRevealAnimations() {
      var items = document.querySelectorAll('.waenn-reveal');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -60px 0px' }
      );

      items.forEach(function (el) { observer.observe(el); });
    }

    function init() {
      initRegalaModal();
      initRevealAnimations();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-waenn-atelier"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DEPOSIT_VARIANT_ID = 58506783261056;

    function initDirectBooking() {
      var openBtn = document.getElementById('WaennOpenBooking');
      var errorMsg = document.getElementById('WaennBookingError');
      if (!openBtn) return;

      var originalText = openBtn.textContent;

      openBtn.addEventListener('click', function () {
        if (openBtn.disabled) return;
        errorMsg && (errorMsg.hidden = true);
        openBtn.disabled = true;
        openBtn.textContent = 'Añadiendo...';

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: DEPOSIT_VARIANT_ID,
                quantity: 1
              }
            ]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart-add-failed');
            return res.json();
          })
          .then(function () {
            window.location.href = root + 'cart';
          })
          .catch(function () {
            openBtn.disabled = false;
            openBtn.textContent = originalText;
            if (errorMsg) errorMsg.hidden = false;
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initDirectBooking);
    } else {
      initDirectBooking();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
